<template>
  <v-card class="e-border--radius e-elevation--3 e-card--progressUnit">
    <v-layout row wrap align-center>
      <v-flex xs4>
        <v-img
          :src="image"
        ></v-img>
      </v-flex>
      <v-flex xs8>
        <v-card-title>
          <div>
            <h3 class="mb-2 e-card--progressUnit--title">{{ title }}</h3>
            <p class="e-card--progressUnit--description"> {{ description }} </p>
            <v-progress-linear :value="progress" color="yellow" height="8" class="mb-0"></v-progress-linear>
          </div>
        </v-card-title>
      </v-flex>
    </v-layout>
  </v-card>
</template>

<script>
export default {
  props: {
    image: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      defult: ''
    },
    description: {
      type: String,
      default: ''
    },
    progress: {
      type: Number,
      default: 50
    }
  }
}
</script>
